var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "custom-callout",
        {
          staticClass: "mb-4 custom-callout-invoice",
          attrs: { "border-color": "orange", "has-toggle": false }
        },
        [
          _c("div", { staticClass: "row py-2" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "dot d-flex justify-content-center align-items-center py-2 px-1 mt-2"
                  },
                  [
                    _c("i", {
                      staticClass:
                        "orange-icon orange-icon-badge-align fas fa-donate"
                    })
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center py-1 px-1 mt-2 ml-2 font-weight-bold"
                  },
                  [_vm._v(" Ajustar Solicitud ")]
                )
              ])
            ])
          ]),
          _c(
            "validation-observer",
            {
              ref: "adjustmentRef",
              staticClass: "pr-4",
              attrs: { novalidate: "", tag: "form" }
            },
            [
              _c("div", { staticClass: "row mt-4" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c("div", { staticClass: "font-14 color-gray-6 mb-1" }, [
                      _vm._v(" ¿Qué tipo de ajuste desea realizar? ")
                    ]),
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-radio", {
                                staticClass: "mt-3 radio-custom font-14",
                                attrs: {
                                  id: "creation-adjustment-adjustmentType",
                                  "custom-error-msg":
                                    "El tipo de ajuste es requerido.",
                                  error: Boolean(errors[0]),
                                  "is-inline": "",
                                  name: "adjustmentType",
                                  options: _vm.adjustmentOptions
                                },
                                model: {
                                  value: _vm.model.adjustmentType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "adjustmentType", $$v)
                                  },
                                  expression: "model.adjustmentType"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12" },
                  [
                    _c("div", { staticClass: "font-14 color-gray-6 mb-1" }, [
                      _vm._v(" Cantidad a ajustar: ")
                    ]),
                    _c("validation-provider", {
                      attrs: {
                        "custom-messages": {
                          required: "La cantidad es requerida.",
                          greaterThanZeroCustomMsg:
                            "La cantidad deber ser mayor a 0."
                        },
                        rules: "required|greaterThanZero"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "input-group mb-3" },
                                [
                                  _c("custom-input", {
                                    staticClass: "w-70",
                                    class: _vm.getAmountClass,
                                    attrs: {
                                      id: "adjustment-amount",
                                      "custom-error-msg":
                                        "La cantidad deber ser mayor a 0.",
                                      error: errors[0],
                                      "mask-type": "Money",
                                      min: 0,
                                      placeholder: "0.00",
                                      "prepend-icon": _vm.getAmountIcon,
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.model.amount,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "amount", $$v)
                                      },
                                      expression: "model.amount"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4 col-sm-12" },
                  [
                    _c("div", { staticClass: "color-gray-6 font-14 mb-2" }, [
                      _vm._v(" Razón: ")
                    ]),
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  id: "adjustment-reason",
                                  "custom-error-msg": "La razón es requerida.",
                                  error: errors[0],
                                  maxlength: "500"
                                },
                                model: {
                                  value: _vm.model.reason,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "reason", $$v)
                                  },
                                  expression: "model.reason"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-8 col-sm-12" },
                  [
                    _c("div", { staticClass: "color-gray-6 font-14 mb-2" }, [
                      _vm._v(" Comentario: ")
                    ]),
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  id: "adjustment-comment",
                                  "custom-error-msg":
                                    "El comentario es requerido.",
                                  error: errors[0],
                                  maxlength: "3000"
                                },
                                model: {
                                  value: _vm.model.comments,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "comments", $$v)
                                  },
                                  expression: "model.comments"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "row ml-2 mt-3 mb-3 d-flex align-items-end justify-content-end"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-6 text-right mt-4" },
                    [
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-times-circle",
                            variant:
                              "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                          },
                          on: { click: _vm.onCancelAdjustment }
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-save",
                            variant: "success pl-4 pr-4"
                          },
                          on: { click: _vm.onSaveAdjustment }
                        },
                        [_vm._v(" Guardar ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }